import { render, staticRenderFns } from "./favoritesList.vue?vue&type=template&id=3c5a562e&scoped=true&"
import script from "./favoritesList.vue?vue&type=script&lang=js&"
export * from "./favoritesList.vue?vue&type=script&lang=js&"
import style0 from "./favoritesList.vue?vue&type=style&index=0&id=3c5a562e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a562e",
  null
  
)

export default component.exports